import axios from "axios";

export default function updateTicketStatus({ id, status }) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/support/api/v1/admin/tickets/${id}/status`, { status })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
